module.exports = __webpack_public_path__ + "static/media/feder-logo.69df1d17.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/feder-logo.jpg
// module id = 699
// module chunks = 0